import { AlertBanner, Box, MarkdownLite, Text } from '@origin-digital/ods-core';
import React from 'react';
import { AlertContainer } from './AlertContainer';

interface IEmptyEmailBannerProps {
  visible: boolean;
  onCloseClicked: () => void;
}

export const EMPTY_EMAIL_BANNER_TEXT =
  "Looks like you didn't sign up to Origin using an email address. You’ll need one to register. Please [get in touch](LIVECHAT), one of our agents can help you out";

export const EmptyEmailBanner: React.FC<IEmptyEmailBannerProps> = ({ visible, onCloseClicked }) =>
  visible ? (
    <AlertContainer tone="critical" data-id="alert-empty-email" onCloseClick={onCloseClicked}>
      <Text>
        <MarkdownLite>{EMPTY_EMAIL_BANNER_TEXT}</MarkdownLite>
      </Text>
    </AlertContainer>
  ) : null;
